/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

document.addEventListener("DOMContentLoaded", function () {
  // Select the container that will have the dynamic elements inserted
  const targetNode = document.body; // You can narrow this down if needed
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(() => {
    const label = document.querySelector('label.subscription-radio[for="rc-radio2"]');
    const sellingPlans = document.querySelector('.rc-selling-plans');

    // Proceed only if both elements exist and not already wrapped
    if (label && sellingPlans && !label.closest('.subscription-wrapper')) {
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.classList.add('subscription-wrapper');

      // Insert wrapper before the label
      label.parentNode.insertBefore(wrapper, label);

      // Move label and sellingPlans inside the wrapper
      wrapper.appendChild(label);
      wrapper.appendChild(sellingPlans);

      // Stop observing once the job is done (optional)
      observer.disconnect();
    }
  });

  // Start observing DOM changes
  observer.observe(targetNode, config);
});

/**
 * Align the PDP to the desired initial variant on page load.
 *
 * Priority:
 * 1. Explicit `?variant=` URL param
 * 2. Merchant-configured default landing variant
 *
 * This keeps the visible selector, hidden form input, ATC price, and Recharge
 * all synchronized without requiring a page refresh.
 */
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('#product-content form[action*="/cart/add"], #product-template form[action*="/cart/add"]')
  if (!form) return

  let variants = []
  try {
    variants = JSON.parse(form.dataset.variants || '[]')
  } catch (e) {
    return
  }

  const urlParams = new URLSearchParams(window.location.search)
  const urlVariantId = Number(urlParams.get('variant'))
  const defaultVariantId = Number(form.dataset.defaultVariantId)
  const targetVariantId = urlVariantId || defaultVariantId

  if (!targetVariantId) return

  const targetVariant = variants.find(function (variant) {
    return variant.id === targetVariantId
  })
  if (!targetVariant) return

  const radiosByName = {}
  form.querySelectorAll('.product-option[type="radio"]').forEach(function (radio) {
    if (!radiosByName[radio.name]) radiosByName[radio.name] = []
    radiosByName[radio.name].push(radio)
  })

  const optionGroupNames = Object.keys(radiosByName)
  let triggerInput = null

  targetVariant.options.forEach(function (optionValue, index) {
    const groupName = optionGroupNames[index]
    if (!groupName) return

    const match = radiosByName[groupName].find(function (radio) {
      return radio.value === optionValue
    })

    if (!match) return

    match.checked = true
    triggerInput = match
  })

  if (!triggerInput) {
    const selects = form.querySelectorAll('select.product-option')

    targetVariant.options.forEach(function (optionValue, index) {
      const select = selects[index]
      if (!select) return

      select.value = optionValue
      triggerInput = select
    })
  }

  const variantInput = form.querySelector('[name="id"]')
  if (variantInput) {
    variantInput.value = targetVariant.id
  }

  if (triggerInput && typeof window.onChangeProductOption === 'function') {
    window.onChangeProductOption(triggerInput)
    return
  }

  if (typeof window.notifyProductVariantIdChanged === 'function') {
    window.notifyProductVariantIdChanged(form, targetVariant)
    return
  }

  if (!variantInput) return

  variantInput.dispatchEvent(new Event('change', { bubbles: true }))
  variantInput.dispatchEvent(new Event('input', { bubbles: true }))
})

/**
 * Recharge Legacy Widget — Variant Sync on Page Load
 *
 * Problem: Recharge's widget loads asynchronously. By the time it mounts,
 * it reads `input[name="id"]` from the form — which is always the first
 * (default) variant when no `?variant=` param is in the URL. Our theme
 * then updates this input on variant card selection, but Recharge may have
 * already attached its listeners to elements it can no longer find after DOM
 * updates, or it may have cached the original variant ID internally.
 *
 * Fix: Listen for Recharge's own "widget is ready" events, then:
 *   1. Tell Recharge to use our hidden input as the variant ID source
 *      (`useVariantIdElement`).
 *   2. Dispatch `change`/`input` on that input so Recharge re-reads the
 *      current variant (handles any value updated before Recharge was ready).
 */
;(function () {
  if (!document.querySelector('#product-template, #product-content')) return

  function getVariantInput() {
    return document.querySelector('#product-content input[name="id"], #product-template input[name="id"]')
  }

  function syncRechargeVariant() {
    const variantInput = getVariantInput()
    if (!variantInput) return

    // Wire Recharge to watch our hidden variant input going forward.
    if (typeof window.ReChargeWidget !== 'undefined') {
      if (typeof window.ReChargeWidget.useVariantIdElement !== 'undefined') {
        window.ReChargeWidget.useVariantIdElement = variantInput
      }
    }

    variantInput.dispatchEvent(new Event('change', { bubbles: true }))
    variantInput.dispatchEvent(new Event('input', { bubbles: true }))
  }

  // Recharge fires these events when the widget finishes building.
  document.addEventListener('ReChargeWidget-loaded', syncRechargeVariant)
  document.addEventListener('widget:build', syncRechargeVariant)

  // Fallback: poll until the rc-widget is in the DOM, then sync once.
  // Covers stores where the above events are not fired on some themes.
  let syncAttempts = 0
  const maxAttempts = 40 // 10 seconds max (40 × 250ms)

  const rcPollInterval = window.setInterval(() => {
    syncAttempts++

    const rcMounted = document.querySelector('.rc-widget, .rc-container')

    if (rcMounted) {
      window.clearInterval(rcPollInterval)
      // Small delay to let Recharge fully initialize its internal state.
      window.setTimeout(syncRechargeVariant, 100)
      return
    }

    if (syncAttempts >= maxAttempts) {
      window.clearInterval(rcPollInterval)
    }
  }, 250)
}())



document.addEventListener('DOMContentLoaded', function() {
  const el = document.querySelector('.delivery-message');
  if (!el) return;

  const startOffset = parseInt(el.dataset.startDays) || 3;
  const endOffset = parseInt(el.dataset.endDays) || 4;
  
  const today = new Date();
  
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + startOffset);
  
  const endDate = new Date(today);
  endDate.setDate(today.getDate() + endOffset);

  const options = { day: 'numeric', month: 'short' };
  
  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const startMonth = startDate.toLocaleString('default', { month: 'long' });
  const endMonth = endDate.toLocaleString('default', { month: 'long' });

  // ordinal suffix helper (1st, 2nd, 3rd, etc.)
  function ordinal(n) {
    const s=["th","st","nd","rd"],
    v=n%100;
    return n+(s[(v-20)%10]||s[v]||s[0]);
  }

  const dateText = startMonth === endMonth 
    ? `${ordinal(startDay)}–${ordinal(endDay)} ${endMonth}`
    : `${ordinal(startDay)} ${startMonth} – ${ordinal(endDay)} ${endMonth}`;

  el.querySelector('.delivery-dates').textContent = dateText;
});

document.addEventListener("DOMContentLoaded", function () {

  var tabButtons = document.querySelectorAll(".megamenu-tab-btn");
  var tabPanes = document.querySelectorAll(".megamenu-content-panel .tab-pane");

  tabButtons.forEach(function (btn) {

    btn.addEventListener("mouseenter", function () {

      var paneId = btn.getAttribute("aria-controls");
      if (!paneId) return;

      var targetPane = document.getElementById(paneId);
      if (!targetPane) return;

      /* Remove active from all buttons */
      tabButtons.forEach(function (b) {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      });

      /* Hide all panes */
      tabPanes.forEach(function (pane) {
        pane.classList.remove("active", "show");
      });

      /* Activate hovered tab */
      btn.classList.add("active");
      btn.setAttribute("aria-selected", "true");

      /* Show matching pane */
      targetPane.classList.add("active", "show");

    });

    /* Prevent click from firing Bootstrap JS */
    btn.addEventListener("click", function (e) {
      e.preventDefault();
    });

  });

});